import React, { useState } from "react";
import {
	PaymentElement,
	useStripe,
	useElements
} from "@stripe/react-stripe-js";
import { StripePaymentElementOptions } from "@stripe/stripe-js";
import { useNavigate } from "react-router-dom";
import { Button } from "./base/Button";
import Section from "./base/Section";
import { Title } from "./base/Title";
import { Checkbox } from "./base/Checkbox";
import { ApiError } from "./ApiError";
import { ChevronLeftIcon } from "@heroicons/react/24/outline";

export const CheckoutForm: React.FC = () => {
	const stripe = useStripe();
	const elements = useElements();
	const navigate = useNavigate();

	const [message, setMessage] = useState<string | undefined>(undefined);
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [acceptCgv, setAcceptCgv] = useState<boolean>(false);
	const [error, setError] = useState<string>();

	const handleSubmit = async (e: any) => {
		e.preventDefault();
		if (!acceptCgv) {
			setError("Vous devez accepter les conditions générales de vente");
			return;
		}

		if (!stripe || !elements) {
			// Stripe.js hasn't yet loaded.
			// Make sure to disable form submission until Stripe.js has loaded.
			return;
		}

		setIsLoading(true);

		const urlRetourPostPaiement = process.env.REACT_APP_RETOUR_URL_POST_PAIEMENT;
		console.log("urlRetourPostPaiement : " + urlRetourPostPaiement)
		if (!urlRetourPostPaiement) throw new Error(
			'Url de retour post paiement non définit, remplir REACT_APP_RETOUR_URL_POST_PAIEMENT dans le .env'
		)

		const { error } = await stripe.confirmPayment({
			elements,
			confirmParams: {
				// Make sure to change this to your payment completion page
				return_url: urlRetourPostPaiement,
			},
		});

		if (error.message) {
			setMessage(error.message);
		} else {
			setMessage("Une erreur est survenue.");
		}

		setIsLoading(false);
	};

	const paymentElementOptions = {
		layout: {
			type: 'accordion',
			defaultCollapsed: false,
			radios: false,
			spacedAccordionItems: true,
			defaultValues: {
				paymentMethod: {
					type: 'card'
				}
			}
		}
	}

	return (
		<Section>
			<Title type='display' className='text-center mb-4'>
				<span className="hidden md:inline">Choisissez votre moyen de paiement</span>
				<span className="md:hidden">Moyen de paiement</span>
			</Title>

			<div className="flex items-center gap-2 mb-4">
				<button className="flex items-center gap-2 text-primary-600 hover:text-primary-700" onClick={() => navigate("/panier")}>
					<ChevronLeftIcon className="w-5 h-5" />
					Retour au panier
				</button>
			</div>
			<form id="payment-form" onSubmit={handleSubmit}>
				<PaymentElement id="payment-element" options={paymentElementOptions as StripePaymentElementOptions} />


				<div className="flex items-center gap-2 mt-4 mb-2">
					<Checkbox id="accept-cgv" checked={acceptCgv} onChange={setAcceptCgv} label="" />
					<label htmlFor="accept-cgv" className="cursor-pointer">
						J'accepte les
						<a href="/informations-legales?tab=1" target="_blank" className="text-primary-600 hover:underline ml-1">conditions générales de vente</a>
					</label>
				</div>
				{error && <ApiError>{error}</ApiError>}

				<div className="flex justify-end my-4">
					<Button disabled={isLoading || !stripe || !elements} id="submit">
						{isLoading ? "Chargement..." : "Payer ma commande"}
					</Button>
					{/* Show any error or success messages */}
				</div>
				{message && <ApiError>{message}</ApiError>}
			</form>
		</Section>
	);
}